import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

import LoadingIndicator from "../../../global/LoadingIndicator";

import ProviderDetailAdditionalContactSection from "./ProviderDetailAdditionalContactSection";
import ProviderDetailHeader from "./ProviderDetailHeader";
import ProviderDetailHoursSection from "./ProviderDetailHoursSection";
import ProviderDetailPrimarySection from "./ProviderDetailPrimarySection";
import ProviderDetailServicesSection from "./ProviderDetailServicesSection";
import { PROVIDER_DETAIL_STYLES } from "./styles";

function getDisplayValue(value) {
  if (value === null || value === undefined || value === "") {
    return "Not available";
  }

  return value;
}

export default function ProviderDetailContent({
  handleViewAllClients,
  isLoading,
  permissionState,
  providerInformation,
  setProviderInformation,
}) {
  const providerSummary = providerInformation?.notes || providerInformation?.summary || "";

  return (
    <>
      <LoadingIndicator isLoading={isLoading} />

      <div className="w-full" style={PROVIDER_DETAIL_STYLES.modalSurface}>
        <div style={PROVIDER_DETAIL_STYLES.contentShell}>
          <ProviderDetailHeader
            providerInformation={providerInformation}
            canEditProvider={permissionState.canEditProvider}
            canViewProvider={permissionState.canViewProvider && !permissionState.isProviderUser}
            handleViewAllClients={handleViewAllClients}
            shouldShowViewAllClients={permissionState.shouldShowViewAllClients}
            onRatingUpdated={(rating) => {
              setProviderInformation((prev) => ({
                ...prev,
                rating,
              }));
            }}
          />
          <div className="grid gap-4 px-1 pb-1 pt-5 md:grid-cols-2">
            <ProviderDetailPrimarySection
              permissionState={permissionState}
              providerInformation={providerInformation}
              setProviderInformation={setProviderInformation}
            />

            <ProviderDetailAdditionalContactSection
              permissionState={permissionState}
              providerInformation={providerInformation}
              setProviderInformation={setProviderInformation}
            />

            <div
              className="rounded-[16px] p-5 md:col-span-2"
              style={PROVIDER_DETAIL_STYLES.sectionCard}
            >
              <div className="flex flex-col gap-3">
                <Typography
                  className="text-[16px] font-semibold"
                  sx={PROVIDER_DETAIL_STYLES.primarySectionTitle}
                >
                  Provider Summary
                </Typography>

                <div className="flex flex-col gap-2">
                  <div
                    className="rounded-[12px] px-4 py-3"
                    style={PROVIDER_DETAIL_STYLES.summaryDisplaySurface}
                  >
                    <Typography
                      className="text-sm leading-7"
                      sx={PROVIDER_DETAIL_STYLES.fieldValue}
                    >
                      {getDisplayValue(providerSummary)}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>

            <ProviderDetailHoursSection
              permissionState={permissionState}
              providerInformation={providerInformation}
              setProviderInformation={setProviderInformation}
            />

            <ProviderDetailServicesSection
              permissionState={permissionState}
              providerInformation={providerInformation}
            />
          </div>
        </div>
      </div>
    </>
  );
}

ProviderDetailContent.propTypes = {
  handleViewAllClients: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  permissionState: PropTypes.object.isRequired,
  providerInformation: PropTypes.object.isRequired,
  setProviderInformation: PropTypes.func.isRequired,
};
